import React from 'react';
import { useTranslation } from 'react-i18next';
import GiftIcon from 'components/atoms/icons/giftIcon';
import BuildingIcon from 'components/atoms/icons/buildingIcon';
import PersonIcon from 'components/atoms/icons/personIcon';
import { ClinicStatus, LoginStatus } from 'infrastructure/enums';
import { prepareDoctorName } from 'infrastructure/functions';

import s from './styles.module.scss';

import type { IPatientDetails } from 'infrastructure/hooks/smsDashboard/usePatientInfo';

interface IProps {
  patientInfo: IPatientDetails | undefined;
}

const SmsDashboardPersonalInfo: React.FC<IProps> = ({ patientInfo }) => {
  const { t } = useTranslation();

  const doctorName = (
    <>
      {prepareDoctorName({
        title: patientInfo?.doctor.title,
        firstName: patientInfo?.doctor.firstName,
        lastName: patientInfo?.doctor.lastName,
      })}
      {patientInfo?.doctor.status === LoginStatus.Inactive && (
        <>
          {' '}
          <span className={s.status}>({t('loginStatuses.inactive')})</span>
        </>
      )}
      {patientInfo?.doctor.status === LoginStatus.Blocked && (
        <>
          {' '}
          <span className={s.status}>({t('loginStatuses.blocked')})</span>
        </>
      )}
    </>
  );

  const clinicName = (
    <>
      {patientInfo?.clinic.legalname}
      {patientInfo?.clinic.status === ClinicStatus.Inactive && (
        <>
          {' '}
          <span className={s.status}>({t('clinicStatuses.inactive')})</span>
        </>
      )}
      {patientInfo?.clinic.status === ClinicStatus.Delinquent && (
        <>
          {' '}
          <span className={s.status}>({t('clinicStatuses.delinquent')})</span>
        </>
      )}
    </>
  );

  const info = [
    {
      icon: <GiftIcon />,
      value: patientInfo?.profile.birthDate,
    },
    {
      icon: <BuildingIcon />,
      value: clinicName,
    },
    {
      icon: <PersonIcon />,
      value: doctorName,
    },
  ];

  return (
    <div className={s.wrapper}>
      {info.map((el, i) => (
        <div key={i} className={s.item}>
          <div className={s.icon}>{el.icon}</div>
          <div className={s.text}>{el.value}</div>
        </div>
      ))}
    </div>
  );
};

export default SmsDashboardPersonalInfo;
